"use client";

import React from "react";

import { SectionTitle } from "../section-title";

import { BoundaryZoneListItemCard } from "./boundary-zone-list-item-card";

import type { IZonesListItem } from "../../../map-panel-context";

interface ZonesListProps {
  sectionTitle: string;
  zones: IZonesListItem[];
  onZoneSelect: (previewId: string, documentId: string) => void;
}

const ZonesListComponent: React.FC<ZonesListProps> = ({ sectionTitle, zones, onZoneSelect }) => {
  if (!sectionTitle && !zones.length) {
    return null;
  }

  return (
    <div>
      {sectionTitle ? <SectionTitle title={sectionTitle} /> : null}

      {zones.length > 0 ? (
        <div className="mt-2 flex flex-col gap-2">
          {zones.map((zone) => (
            <BoundaryZoneListItemCard
              key={`${zone.documentId}-${zone.previewId}`}
              label={zone.label}
              previewColor={zone.previewColor}
              previewCoordinates={zone.previewCoordinates}
              schoolId={zone.schoolId}
              onClick={() => onZoneSelect(zone.previewId, zone.documentId)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export const ZonesList = React.memo(ZonesListComponent);
